import React, { useContext, useState } from "react";
import { TextField, Button, Checkbox, DialogActions, FormGroup, FormControlLabel, Stack, Typography, Backdrop, CircularProgress, Box, MenuItem } from "@mui/material";
import { API } from "../conf";
import { Context } from "../App";
import { banques, compte_type, fedcompte_type } from "../asset/variables";

const organisation = JSON.parse(sessionStorage.getItem('eglise'))

export function CompteForm(props) {
    const { updateConnect } = useContext(Context)
    const [loading, setLoad] = useState(false)
    const [libelle, setLabel] = useState('')
    const [num_compte, setNum] = useState('')
    const [is_departement, setDeptm] = useState(false)
    const [is_offrande, setOffrande] = useState(false)
    const [is_hors_budget, setHorsBdg] = useState(true)
    const [type, setType] = useState('')
    const [banque, setBanque] = useState('')
    const [num_banque, setNumBnque] = useState('')
    const [solde, setSolde] = useState(0)
    const [percent, setPercent] = useState(0)
    const [prevision, setPrevision] = useState(0)
    const [msg, setMsg] = useState()

    function handleSubmit() {
        setLoad(true); setMsg()
        var eglise = props.eglise._id
        const ecart = -prevision
        fetch(API.concat(`/comptes/create`), {method: 'POST', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, 
            body: JSON.stringify({libelle, num_compte, type, banque, num_banque, is_offrande, is_departement, is_hors_budget, solde, percent, prevision, ecart, eglise})
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200){
                    const compte = await response.json()
                    props.updateComptes(compte)
                    props.close()
                }
                if(response.status === 403){
                    const text = await response.text()
                    setMsg(text)
                }
                setLoad(false)
            }
        })
    }

    return(
        <Box sx={{paddingInline:'20px', paddingBlock:'30px'}} >
            <Typography variant="h5" textAlign='center'>Ajouter un compte</Typography>
            <Stack direction='column' spacing={2} sx={{paddingTop:'10px'}}>
                <Stack direction='row' spacing={2}>
                    {[...fedcompte_type,'petite-caisse', 'liaison'].includes(type)&&<TextField required={['liaison', 'petite-caisse'].includes(type)} sx={{width:'35%', minWidth:'150px'}} label={"N° compte"}
                    value={num_compte} onChange={(e)=>setNum(e.target.value)}/>}
                    <TextField autoFocus fullWidth required={type!=='petite-caisse'} sx={{minWidth:'200px'}} label="Libellé"
                    value={libelle} onChange={(e)=>setLabel(e.target.value)}
                    />
                </Stack>
                <Stack direction='row' spacing={2}>
                    <TextField select required fullWidth label='Type de compte' sx={{minWidth:'150px'}} value={type} onChange={e=>setType(e.target.value)}>
                        {[...(organisation.isFederation ? [...compte_type, ...fedcompte_type] : compte_type).sort(), 'autre'].flat().map((item, index)=><MenuItem key={index} value={item} sx={{textTransform:'capitalize'}}>{item}</MenuItem>)}
                    </TextField>
                    <TextField type="number" sx={{width:'30%', minWidth:'150px'}} label={"Solde"}
                    value={solde} onChange={(e)=>setSolde(Number(e.target.value))}/>
                </Stack>
                {type==='banque'?<Stack direction='row' spacing={2} alignItems='center'>
                    <TextField select label='Banque' required fullWidth value={banque} onChange={e=>setBanque(e.target.value)}>
                        {banques.map((banque, index)=><MenuItem key={index} value={banque}>{banque}</MenuItem>)}
                    </TextField>
                    <TextField required fullWidth label='N° compte bancaire' value={num_banque} onChange={e=>setNumBnque(e.target.value)}/>
                </Stack>
                :<><Stack direction='row' spacing={2}>
                    <TextField type="number" fullWidth sx={{minWidth:'70px'}} label={"Poucentage offrande globale"} disabled={is_hors_budget}
                    value={percent} onChange={(e)=>{
                        if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)<=100) {
                            setPercent(Number(e.target.value))   
                        } else if(e.target.value==='')setPercent('')
                    }}/>
                    <TextField type="number" fullWidth sx={{ minWidth:'70px'}} label="Budget prévionnel"
                    value={prevision} onChange={(e)=>{
                    if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0) {
                        setPrevision(Number(e.target.value))   
                    } else if(e.target.value===''){
                        setPrevision('')
                    }
                }}/>
                </Stack>
                
                {![...fedcompte_type,'petite-caisse', 'liaison'].includes(type)&&<FormGroup>
                    <FormControlLabel control={<Checkbox checked={is_departement} onChange={()=>setDeptm(old=>!old)} />} label="département" />
                    <FormControlLabel control={<Checkbox checked={is_offrande} onChange={()=>setOffrande(old=>!old)} />} label="offrande" />
                    <FormControlLabel control={<Checkbox checked={is_hors_budget} onChange={()=>setHorsBdg(old=>!old)} />} label="hors budget" />
                </FormGroup>}
                </>}
                <Typography variant="info" color='error'>{msg}</Typography>
            </Stack>
            <DialogActions>
                <Button variant="outlined" onClick={props.close}>Annuler</Button>
                <Button variant="contained" disabled={libelle.replaceAll(' ', '').length < 2 || (['liaison', 'petite-caisse'].includes(type)&&num_compte.replaceAll(' ', '').length < 5)} onClick={handleSubmit}>Enregistrer</Button>
            </DialogActions>
            <Backdrop open={loading} ><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}

export function EditCompteForm(props) {
    const { updateConnect } = useContext(Context)
    const [loading, setLoad] = useState(false)
    const [libelle, setLabel] = useState(props.compte.libelle)
    const [num_compte, setNum] = useState(props.compte.num_compte)
    const [is_departement, setDeptm] = useState(props.compte.is_departement)
    const [is_offrande, setOffrande] = useState(props.compte.is_offrande)
    const [is_hors_budget, setHorsBdg] = useState(props.compte.is_hors_budget)
    const [type, setType] = useState(props.compte?.type??'')
    const [banque, setBanque] = useState(props.compte?.banque??'')
    const [num_banque, setNumBnque] = useState(props.compte?.num_banque??'')
    const [solde, setSolde] = useState(props.compte.solde)
    const [percent, setPercent] = useState(props.compte.percent)
    const [prevision, setPrevision] = useState(0)
    const [msg, setMsg] = useState()

    function handleSubmit() {
        setLoad(true); setMsg()
        fetch(API.concat(`/comptes/${props.compte?.eglise}/${props.compte?._id}`), {method: 'PATCH', headers:{
            Accept: 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('token')
            }, 
            body: JSON.stringify({libelle, num_compte, type, banque, num_banque, is_offrande, is_departement, is_hors_budget, init_solde: solde, percent})
        }).then(async(response)=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200){
                    const compte = props.compte
                    compte.libelle=libelle; compte.num_compte=num_compte; compte.type=type; compte.is_offrande= is_offrande; compte.is_departement= is_departement; compte.is_hors_budget= is_hors_budget; compte.solde= Number(solde); compte.percent= Number(percent)
                    props.updateCompte(compte)
                    props.close()
                }
                if(response.status === 403){
                    const text = await response.text()
                    setMsg(text)
                }
                setLoad(false)
            }
        })
    }

    return(
        <Box component='form' onSubmit={e=>{e.preventDefault();handleSubmit()}} sx={{paddingInline:'20px', paddingBlock:'30px'}} >
            <Typography variant="h5" textAlign='center' marginBottom={3}>Modifier le compte n°{props.compte.num_compte} <span style={{textTransform:'capitalize'}}>{props.compte.libelle}</span></Typography>
            <Stack direction='column' spacing={2} sx={{paddingTop:'10px'}}>
                <Stack direction='row' spacing={2}>
                    {[...fedcompte_type,'petite-caisse', 'liaison'].includes(type)&&<TextField required={['liaison', 'petite-caisse'].includes(type)} sx={{width:'35%', minWidth:'150px'}} label={"N° compte"}
                    value={num_compte} onChange={(e)=>setNum(e.target.value)}/>}
                    <TextField autoFocus fullWidth required={type!=='petite-caisse'} sx={{minWidth:'200px'}} label="Libellé"
                    value={libelle} onChange={(e)=>setLabel(e.target.value)}/>
                </Stack>
                <Stack direction='row' spacing={2}>
                    <TextField select required fullWidth label='Type de compte' sx={{minWidth:'150px'}} value={type} onChange={e=>setType(e.target.value)}>
                        {[...(organisation.isFederation ? [...compte_type, ...fedcompte_type] : compte_type).sort(), 'autre'].flat().map((item, index)=><MenuItem key={index} value={item} sx={{textTransform:'capitalize'}}>{item}</MenuItem>)}
                    </TextField>
                    <TextField type="number" sx={{width:'30%', minWidth:'150px'}} label={"Solde initial"}
                    value={solde} onChange={(e)=>{if(/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){setSolde(Number(e.target.value))} else if(e.target.value==='') setSolde('')}}/>
                </Stack>
                {type==='banque'?<Stack direction='row' spacing={2} alignItems='center'>
                    <TextField select label='Banque' required fullWidth value={banque} onChange={e=>setBanque(e.target.value)}>
                        {banques.map((banque, index)=><MenuItem key={index} value={banque}>{banque}</MenuItem>)}
                    </TextField>
                    <TextField required fullWidth label='N° compte bancaire' value={num_banque} onChange={e=>setNumBnque(e.target.value)}/>
                </Stack>
                :<><Stack direction='row' spacing={2}>
                    <TextField type="number" fullWidth sx={{minWidth:'70px'}} label={"Poucentage offrande globale"} disabled={is_hors_budget}
                    value={percent} onChange={(e)=>{
                        if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)<=100) {
                            setPercent(Number(e.target.value))   
                        } else if(e.target.value==='')setPercent('')
                    }}/>
                    <TextField type="number" fullWidth sx={{ minWidth:'70px'}} label="Budget prévionnel"
                    value={prevision} onChange={(e)=>{
                    if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0) {
                        setPrevision(Number(e.target.value))   
                    } else if(e.target.value===''){
                        setPrevision('')
                    }
                }}/>
                </Stack>
                
                {![...fedcompte_type,'petite-caisse', 'liaison'].includes(type)&&<FormGroup>
                    <FormControlLabel control={<Checkbox checked={is_departement} onChange={()=>setDeptm(old=>!old)} />} label="département" />
                    <FormControlLabel control={<Checkbox checked={is_offrande} onChange={()=>setOffrande(old=>!old)} />} label="offrande" />
                    <FormControlLabel control={<Checkbox checked={is_hors_budget} onChange={()=>setHorsBdg(old=>!old)} />} label="hors budget" />
                </FormGroup>}</>}
                <Typography variant="info" color='error'>{msg}</Typography>
            </Stack>
            <DialogActions>
                <Button variant="outlined" onClick={props.close}>Annuler</Button>
                <Button variant="contained" disabled={libelle.replaceAll(' ', '').length < 2 || (['liaison', 'petite-caisse'].includes(type)&&num_compte.replaceAll(' ', '').length < 5)} type="submit">Enregistrer</Button>
            </DialogActions>
            <Backdrop open={loading} ><CircularProgress color="inherit" /></Backdrop>
        </Box>
    )
}